import * as React from "react";

import { InputContainer, InputContainerProps } from "./input-container";

interface ValueSelectGridInputProps<T> extends InputContainerProps {
  possibleValues: readonly T[];
  onChange: (name: string, selectedPossibleValue: T) => void;
  keyForPossibleValue: (possibleValue: T) => string;
  presentPossibleValueString: (possibleValue: T) => string;
}

const header: React.FunctionComponent = (props) => {
  return <h2 className="title">{props.children}</h2>;
};

export const ValueSelectGridInput = <T extends unknown>(
  props: React.PropsWithChildren<ValueSelectGridInputProps<T>>
): React.ReactElement<any, any> | null => {
  const possibleValues = React.useMemo(() => {
    return props.possibleValues.map((possibleValue) => {
      return (
        <ValueSelectGridInputItem
          key={props.keyForPossibleValue(possibleValue)}
          possibleValue={possibleValue}
          selectedPossibleValue={props.form[props.name]}
          name={props.name}
          onChange={props.onChange}
          presentPossibleValueString={props.presentPossibleValueString}
        />
      );
    });
  }, [
    props.possibleValues,
    props.name,
    props.form,
    props.onChange,
    props.presentPossibleValueString,
  ]);

  return (
    <InputContainer
      {...props}
      className="value-select-grid-input"
      header={header}
    >
      <div className="value-select-grid">{possibleValues}</div>
    </InputContainer>
  );
};

interface ValueSelectGridInputItemProps<T> {
  name: string;
  possibleValue: T;
  selectedPossibleValue: T;
  onChange: (name: string, selectedPossibleValue: T) => void;
  presentPossibleValueString: (value: T) => string;
}

const ValueSelectGridInputItem = <T extends unknown>(
  props: React.PropsWithChildren<ValueSelectGridInputItemProps<T>>
): React.ReactElement<any, any> | null => {
  const possibleValueString = React.useMemo(() => {
    return props.presentPossibleValueString(props.possibleValue);
  }, [props.presentPossibleValueString, props.possibleValue]);
  const isActive = React.useMemo(() => {
    return props.selectedPossibleValue === props.possibleValue;
  }, [props.selectedPossibleValue, props.possibleValue]);
  const onClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    event.preventDefault();
    props.onChange(props.name, props.possibleValue);
  };
  return (
    <button
      type="button"
      className={`possible-value ${isActive ? "active" : "inactive"}`}
      onClick={onClick}
    >
      {possibleValueString}
    </button>
  );
};
